import { render } from "./TheSubscriptionsProductGenerals.vue?vue&type=template&id=13935f8c"
import script from "./TheSubscriptionsProductGenerals.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionsProductGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__